import 'lazysizes';
import React, { forwardRef, HTMLAttributes } from 'react';
import styled from 'styled-components';
import { getSrcset } from '../utils/getSrcset';

interface Props extends HTMLAttributes<HTMLImageElement> {
    alt: string;
    imageSrc: string;
    inModal?: boolean;
}

const Img = forwardRef<HTMLImageElement | null, Props>(
    ({ alt, imageSrc, inModal = false, ...props }, ref) => {
        // Only for IE.
        const fallbackSrc = imageSrc.replace(
            'q_auto',
            `q_auto,w_${inModal ? 660 : 350}`
        );

        const srcSetValues = inModal ? [2400, 1200, 660, 576, 320] : [350, 180];

        return (
            <Image
                alt={alt}
                data-src={fallbackSrc}
                data-srcset={getSrcset(imageSrc, srcSetValues)}
                {...props}
                ref={ref}
            />
        );
    }
);

Img.displayName = 'Img';

const Image = styled.img`
    height: auto;
    width: 100%;
`;

export default Img;
